import React from 'react'
import PropTypes from 'prop-types'
import { getBrowserDetails } from 'libs/browserData'
import useResetPaddingTopMobile from 'libs/hooks/useResetPaddingTopMobile'
import _ from 'lodash'
import UnsupportedBrowser from '../UnsupportedBrowser'

function BrowserCheck(props) {
  const { children, t } = props
  const browserDetails = getBrowserDetails()
  const hasSupportedBrowser = _.get(browserDetails, ['check'])
  useResetPaddingTopMobile(hasSupportedBrowser)

  return (
    <div>
      <If condition={!hasSupportedBrowser}>
        <UnsupportedBrowser browserDetails={browserDetails} t={t} />
        <Else />
        {children}
      </If>
    </div>
  )
}

BrowserCheck.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired
}

export default BrowserCheck
